import React from 'react'

import { H3 } from '@mxenabled/mxui'

import type { GlobalCaptureException } from '../../core'

export interface ErrorProps {
  children?: React.ReactNode
  onCaptureException?: GlobalCaptureException
}

export interface ErrorState {
  hasError: boolean
}

const copy = {
  text: 'Oops! Something went wrong.',
}

class ErrorBoundary extends React.Component<ErrorProps, ErrorState> {
  state: ErrorState = {
    hasError: false,
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo)
    this.props.onCaptureException?.(error, {
      component: 'ErrorBoundary',
      componentStack: errorInfo.componentStack ?? '',
    })
  }

  static getDerivedStateFromError(): ErrorState {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError) return <H3 sx={{ pt: 24 }}>{copy.text}</H3>

    return this.props.children
  }
}

export default ErrorBoundary
